var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.242021 10.691C-0.074385 11.0074 -0.089452 11.5724 0.249555 11.9039C0.581028 12.2353 1.14604 12.2278 1.46245 11.9114L6.07294 7.29336L10.691 11.9114C11.0149 12.2353 11.5724 12.2353 11.9039 11.9039C12.2278 11.5648 12.2353 11.0149 11.9039 10.691L7.29336 6.07294L11.9039 1.46245C12.2353 1.13851 12.2353 0.581028 11.9039 0.249555C11.5648 -0.074385 11.0149 -0.0819185 10.691 0.242021L6.07294 4.86005L1.46245 0.242021C1.14604 -0.074385 0.573494 -0.089452 0.249555 0.249555C-0.0819185 0.581028 -0.074385 1.14604 0.242021 1.46245L4.86005 6.07294L0.242021 10.691Z",
    fill: "#3F3D56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.0e4a5eabb272af253fee9e11ed3d4857.svg";
export { ForwardRef as ReactComponent };